import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import { useLocalStorage } from '@mantine/hooks';
import { Notifications } from '@mantine/notifications';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import './sentryConfig';

import App from './app/app';
import { TenantPreLoader } from './components/tenantpreloader/TenantPreLoader';
import { COLOR_SCHEME_STORAGE_KEY } from './utils/constants';
import { queryClient } from './utils/queryClient';
import { RELEASE_VERSION, ROUTE_BASE_NAME } from './config';

console.log(
  '%cPortal-Next version: %s',
  'font-size: 16px; font-family: "Arial Black", sans-serif; border: 2px solid #B32728; padding: 10px',
  RELEASE_VERSION
);

const root = ReactDOM.createRoot(
  document.querySelector('#root') as HTMLElement
);

function Application() {
  const [colorScheme] = useLocalStorage<'dark' | 'light' | undefined>({
    getInitialValueInEffect: false,
    key: COLOR_SCHEME_STORAGE_KEY,
  });
  return (
    <StrictMode>
      <BrowserRouter basename={ROUTE_BASE_NAME}>
        {/* MantineProvider creates an emotion cache */}
        <MantineProvider forceColorScheme={colorScheme}>
          <Notifications />
          <QueryClientProvider client={queryClient}>
            <TenantPreLoader>
              {(tenantLoginInfoData) => <App {...tenantLoginInfoData} />}
            </TenantPreLoader>
            <ReactQueryDevtools />
          </QueryClientProvider>
        </MantineProvider>
      </BrowserRouter>
    </StrictMode>
  );
}

root.render(<Application />);
